import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardPSPegawai from 'app/KinerjaPSPegawaiPage/components/PageGuardPSPegawai'
import TugasPokokPage from 'app/KinerjaPSPegawaiPage/pages/Perencanaan/TugasPokok'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-penilik-pegawai-enabled'] || false
    const enabledPerencanaan =
      toggle?.['kinerja-penilik-pegawai-perencanaan-enabled'] || false

    if (!enabled || !enabledPerencanaan) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page: KinerjaApp = () => (
  <PageGuardPSPegawai>
    <TugasPokokPage />
  </PageGuardPSPegawai>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
  pageTitle: 'Pengelolaan Kinerja Penilik - Perencanaan - Tugas Pokok',
}

export default Page
